import './styles.scoped.css';
export default {
  "root": "awsui_root_1t44z_1pd21_93",
  "dismissable": "awsui_dismissable_1t44z_1pd21_105"
};